module.exports = __webpack_public_path__ + "static/media/noatecLogo1.4491cee9.png";